import { styled } from '@linaria/react'

export const Rhytm = styled.div<{
  gap?: string
  gridFlowDirection?: 'row' | 'column'
  alignItems?: string
}>`
  display: grid;
  grid-gap: ${props => props.gap || '12px'};
  gap: ${props => props.gap || '12px'};
  grid-auto-flow: ${props => props.gridFlowDirection || 'row'};
  align-items: ${props => props.alignItems || 'center'};
`
